<template>
  <Form :title="title" :loading="loading" @submit="onSubmit" @reset="onReset">
    <h4>Dati</h4>
    <v-row>
      <FormItem
        v-model="label"
        name="label"
        label="Nome Operazione"
        rules="required"
        :cols="12"
        :sm="12"
        :md="6"
        :lg="6"
        :xl="6"
        @input="setKeyFromLabel"
      />

      <FormItem
        v-model="key"
        label="Chiave"
        name="key"
        :disabled="true"
        :cols="12"
        :sm="12"
        :md="6"
        :lg="6"
        :xl="6"
      />
    </v-row>
    <h5
      >Seleziona una sezione se vuoi rendere l'operazione valida solo in quella
      sezione</h5
    >
    <v-row>
      <SectionsSelect
        v-model="section"
        :cols="12"
        :sm="12"
        :md="12"
        :lg="12"
        :xl="12"
      />
    </v-row>
  </Form>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import { mapActions, mapMutations, mapState } from 'vuex'

import Form from '@components/forms/Form.vue'
import FormItem from '@components/forms/FormItem.vue'
import SectionsSelect from '@components/admin/sections/SectionsSelect.vue'

const { mapFields } = createHelpers({
  getterType: 'operations/getCurrent',
  mutationType: 'operations/SET_CURRENT_FIELDS',
})

export default {
  name: 'OperationsForm',
  components: {
    FormItem,
    Form,
    SectionsSelect,
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Crea Nuovo',
    },
  },
  computed: {
    ...mapFields(['key', 'label', 'section']),
    ...mapState('operations', {
      id: (state) => state.current.id,
      loading: (state) => state.loading,
    }),
  },
  methods: {
    ...mapMutations('operations', {
      reset: 'RESET_CURRENT',
      setCurrentValues: 'SET_CURRENT',
      setKeyFromLabel: 'SET_KEY_FROM_LABEL',
    }),
    ...mapActions('operations', ['create', 'update']),
    async onSubmit() {
      this.$emit('submit')

      if (!this.edit) {
        await this.create()
      } else {
        await this.update()
      }

      this.$emit('submitted', this.id)
    },
    onReset() {
      this.reset()
      this.$emit('resetted')
    },
  },
}
</script>

<style scoped></style>
